(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article"]) return;
  try {
    
/* Build a TOC from h2/h3 inside .article-body, link by id. */
document.addEventListener('DOMContentLoaded', function() {
  var toc = document.getElementById('js-toc');
  if (!toc) return;

  var body = document.querySelector('.article-body');
  if (!body) return;

  var maxDepth = '{{ section.settings.toc_depth | default: "2" }}';
  var selector = (maxDepth === '3') ? 'h2, h3, h4' : 'h2, h3';
  var headings = body.querySelectorAll(selector);

  if (!headings.length) { toc.innerHTML = '<div class="toc-empty">No headings</div>'; return; }

  var list = document.createElement('ol');
  headings.forEach(function(h, idx) {
    if (!h.id) {
      h.id = 'sec-' + (idx + 1) + '-' + h.textContent.trim().toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/(^-|-$)/g,'');
    }
    var li = document.createElement('li');
    li.className = 'toc-item toc-item--' + h.tagName.toLowerCase();
    var a = document.createElement('a');
    a.href = '#' + h.id;
    a.textContent = h.textContent;
    li.appendChild(a);
    list.appendChild(li);
  });
  toc.appendChild(list);

  /* Mobile: collapsible TOC */
  var toggle = document.querySelector('.toc-toggle');
  var card = document.getElementById('toc-card');
  if (toggle && card) {
    toggle.addEventListener('click', function() {
      var open = card.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog"]) return;
  try {
    
/* Build TOC from h2/h3 */
document.addEventListener('DOMContentLoaded', function() {
  var toc = document.getElementById('js-toc');
  if (!toc) return;
  var body = document.querySelector('.article-body');
  if (!body) return;

  var selector = '{{ section.settings.toc_depth | default: "2" }}' === '3' ? 'h2, h3, h4' : 'h2, h3';
  var headings = body.querySelectorAll(selector);
  if (!headings.length) { toc.innerHTML = '<div class="toc-empty">No headings</div>'; return; }

  var list = document.createElement('ol');
  headings.forEach(function(h, i) {
    if (!h.id) {
      h.id = 'sec-' + (i+1) + '-' + h.textContent.trim().toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/(^-|-$)/g,'');
    }
    var li = document.createElement('li');
    li.className = 'toc-item toc-item--' + h.tagName.toLowerCase();
    var a = document.createElement('a');
    a.href = '#' + h.id;
    a.textContent = h.textContent;
    li.appendChild(a);
    list.appendChild(li);
  });
  toc.appendChild(list);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-section"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  var faqToggles = document.querySelectorAll('[data-faq-toggle]');
  faqToggles.forEach(function(button) {
    button.addEventListener('click', function() {
      var faqItem = this.closest('.faq-item');
      var answer = faqItem.querySelector('.faq-answer');
      var isExpanded = this.getAttribute('aria-expanded') === 'true';
      this.setAttribute('aria-expanded', String(!isExpanded));
      answer.setAttribute('aria-hidden', String(isExpanded));
      faqItem.classList.toggle('faq-item--expanded');
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
